var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h2", [_vm._v(_vm._s(_vm.dictionaries.globalContactHeadline))]),
    _vm._v(" "),
    _vm.products.length > 0
      ? _c("div", { staticClass: "filter-section" }, [
          _c("div", { staticClass: "filter-items" }, [
            _vm.products.length > 0 && _vm.countries.length > 0
              ? _c("div", { staticClass: "filter-item filter-item--mw" }, [
                  _c("p", { staticClass: "filter-item filter-item__text" }, [
                    _vm._v(_vm._s(_vm.dictionaries.globalContactFilterLabel)),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.products.length > 0
              ? _c("div", { staticClass: "filter-item filter-item--mw" }, [
                  _c(
                    "label",
                    { staticClass: "sr-only", attrs: { for: "productSelect" } },
                    [
                      _vm._v(
                        _vm._s(_vm.dictionaries.globalContactFilterProductLabel)
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.product,
                          expression: "product",
                        },
                      ],
                      staticClass: "filter-item__select",
                      attrs: { name: "productSelect", disabled: _vm.isLoading },
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.product = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          function ($event) {
                            return _vm.filterChanged(true)
                          },
                        ],
                      },
                    },
                    [
                      _c("option", { attrs: { value: "All" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.dictionaries.globalContactFilterProductLabel
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.products, function (product, index) {
                        return product.name
                          ? _c("option", { domProps: { value: product.key } }, [
                              _vm._v(_vm._s(product.name)),
                            ])
                          : _vm._e()
                      }),
                    ],
                    2
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.products.length > 0 && _vm.countries.length > 0
              ? _c("div", { staticClass: "filter-item filter-item--mw" }, [
                  _c(
                    "label",
                    { staticClass: "sr-only", attrs: { for: "countrySelect" } },
                    [
                      _vm._v(
                        _vm._s(_vm.dictionaries.globalContactFilterCountryLabel)
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.country,
                          expression: "country",
                        },
                      ],
                      staticClass: "filter-item__select",
                      attrs: { name: "countrySelect", disabled: _vm.isLoading },
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.country = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          function ($event) {
                            return _vm.filterChanged(false)
                          },
                        ],
                      },
                    },
                    [
                      _c("option", { attrs: { value: "All" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.dictionaries.globalContactFilterCountryLabel
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.countries, function (country, index) {
                        return country.name
                          ? _c("option", { domProps: { value: country.key } }, [
                              _vm._v(_vm._s(country.name)),
                            ])
                          : _vm._e()
                      }),
                    ],
                    2
                  ),
                ])
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "ul",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.employees.length,
            expression: "employees.length",
          },
        ],
        staticClass: "employee-items",
      },
      _vm._l(_vm.employees, function (employee) {
        return _c("Employee", {
          key: employee.id,
          attrs: { employee: employee },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/scripts/vue/globalcontact.vue